<script>
import CriteriaBlock from "@/view/pages/test-input/components/ComponentMarkTheExam/CriteriaBlock.vue";
import {SpeakingCriteria} from "@/core/option/newTestInputOption";
import {MAKE_EXAM_SPEAKING} from "@/core/services/store/test/testInput.module";
import router from "@/router";

export default {
  name: "NewMarkSpeaking",
  components: {CriteriaBlock},
  props: {
    criteria: {
      type: Array,
      default: null
    },
    version: {
      type: [Number, String],
      default: 2
    }
  },
  data() {
    return {
      speakingCriteria: JSON.parse(JSON.stringify(this.criteria || SpeakingCriteria))
    }
  },
  methods:{
    async confirm(){
      let data = {
        type: "speaking",
        criterias: this.speakingCriteria.map((criteria)=>{
          return {
            key: criteria.apiName,
            point: criteria.point,
            comment: criteria.specificComment,
            comment_auto: criteria?.pointList?.find(point => point.band === criteria.point)?.eComment??'',
            v_comment_auto: criteria?.pointList?.find(point => point.band === criteria.point)?.vComment??''
          }
        }),
        version: +this.version
      }
      let test_input_schedule_id = this.$route.params.id
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      await this.$store.dispatch(MAKE_EXAM_SPEAKING, {id: test_input_schedule_id, data: data}).then(()=>{
        this.$message.success('Chấm Speaking thành công');
        router.push({name: 'task-details', params: {id: test_input_schedule_id}})
      }).finally(() => {
        loading.close();
      })
    }
  }

}
</script>

<template>
  <div>
    <ValidationObserver v-slot="{ handleSubmit }" ref="form">
      <form @submit.prevent>
        <section style="height: 650px; overflow-y: scroll">
          <div v-for="(criterion, index) in speakingCriteria" :key="index" class="mb-6">
            <CriteriaBlock :criterion="criterion"></CriteriaBlock>
          </div>
        </section>
        <div class="d-flex justify-content-end mt-6">
          <button type="button" class="btn btn-primary" @click="handleSubmit(confirm)">Hoàn thành</button>
        </div>
      </form>
    </ValidationObserver>
  </div>

</template>

<style scoped>

</style>
